import React from 'react';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import { Field } from '../attributes';

type TimeAttributeEditorProps = {
    field: Field;
};

export default (props: TimeAttributeEditorProps) => {
    const { field } = props;
    return (
            <FormContainer>
                <FormItem>
                    <FormWidget name={field.name} label={field.label} component="Time" />
                </FormItem>
            </FormContainer>
    );
};
